import { withCompInfo } from '@wix/editor-elements-integrations'
import { colorApi } from '@wix/thunderbolt-becky-root'
import { PaginatedGridGalleryCarmiCss, PaginatedGridGalleryDefinition } from '@wix/thunderbolt-components-native'

export const css = withCompInfo<PaginatedGridGalleryCarmiCss, PaginatedGridGalleryDefinition>()(
	['styleProperties', 'siteColors'],
	({ styleProperties, siteColors }) =>
		colorApi.getBrightnessCSSVars<PaginatedGridGalleryCarmiCss>({
			paramName: 'bg2',
			mutatedParamName: 'button-border-color',
			fallbackName: 'bg1',
			siteColors,
			alpha: 0.5,
			styleProperties,
		})
)
